import Vue from 'vue';
import { BrandingData, GlobalConfig, GlobalConfigState } from '@/interfaces/config';

export function storeConfig(state: GlobalConfigState, config: GlobalConfig) {
  Object.entries(config).forEach(([key, value]: [string, string]) => {
    Vue.set(state, key, value);
  });
}

export function storeBrandingConfig(state: GlobalConfigState, brandingData: BrandingData) {
  Vue.set(state, 'BRANDING_CONFIG', brandingData);
}
